<script setup>
import {computed, onMounted, ref} from "vue";
import projectsTasksService from "@/services/projects-tasks.service";
import ProjectTaskActivitiesItem from "@/components/tasks/viewProjectTask/ProjectTaskActivitiesItem.vue";

const {taskId} = defineProps(['taskId']);
const emit = defineEmits(['commentAdded']);

const activities = ref([]);
const newComment = ref('');
const activitiesType = ref('comment');

const currentActivities = computed(() => {
    if (activitiesType.value === 'all') {
        return activities.value;
    }

    return activities.value.filter(activity => activity.type === activitiesType.value);
});

onMounted(() => {
    getActivities();
});

async function addComment() {
    await projectsTasksService.addComment(taskId, {text: newComment.value});

    newComment.value = '';
    getActivities();
    emit('commentAdded');
}

async function getActivities() {
    const {data} = await projectsTasksService.getActivities(taskId);

    activities.value = data;
}

async function updateComment(id, text) {
    await projectsTasksService.updateComment(id, {text});

    getActivities();
}

async function deleteComment(id) {
    if (!confirm('Delete comment?')) {
        return;
    }

    await projectsTasksService.deleteComment(id);

    getActivities();
}

defineExpose({
    getActivities
});

</script>

<template>
    <div class="activity-section">
        <div class="activity-section__filter d-none">
            <b-dropdown id="dropdown-1" text="Filter" class="dropdown-filter mr-3">
                <b-dropdown-item>Something</b-dropdown-item>
            </b-dropdown>
            <b-dropdown id="dropdown-1" text="Newest" class="dropdown-sort">
                <b-dropdown-item>Something</b-dropdown-item>
            </b-dropdown>
        </div>
        <!--  -->
        <b-tabs class="activity-tabs">
            <b-tab
                title="All"
                :active="activitiesType === 'all'"
                @click="activitiesType = 'all'"
            />
            <b-tab
                title="Comments"
                :active="activitiesType === 'comment'"
                @click="activitiesType = 'comment'"
            />
            <b-tab
                title="Logs"
                :active="activitiesType === 'log'"
                @click="activitiesType = 'log'"
            />
        </b-tabs>

        <div class="comments-section">
            <input
                type="text"
                v-model="newComment"
                placeholder="Add a comment…"
                class="comments-section__input"
                @keydown.enter="addComment"
            >

            <ul class="list-comments">
                <ProjectTaskActivitiesItem
                    v-for="activity in currentActivities"
                    :key="activity.type + '-' + activity.id"
                    :activity="activity"
                    @updateComment="(text) => updateComment(activity.id, text)"
                    @deleteComment="() => deleteComment(activity.id)"
                />
            </ul>
        </div>
    </div>
</template>

<style scoped>

</style>
